import { render } from "./TheDialog.vue?vue&type=template&id=163a2544&scoped=true&ts=true"
import script from "./TheDialog.vue?vue&type=script&lang=ts"
export * from "./TheDialog.vue?vue&type=script&lang=ts"

import "./TheDialog.vue?vue&type=style&index=0&id=163a2544&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163a2544"]])

export default __exports__